import React from "react";

import { useHistory } from "react-router-dom";

import Icon from "../icon";

import * as S from "./styles";

import IProps from "./props";

const BackButtom: React.FC<IProps> = ({ text }) => {
  const history = useHistory();

  const handleBack = (): void => {
    history.goBack();
  };

  return (
    <S.Container>
      <S.Button onClick={handleBack}>
        <Icon name="arrow-left" />
      </S.Button>
      <S.Text>{text}</S.Text>
    </S.Container>
  );
};

export default BackButtom;
